import React from "react"
import { Div } from "atomize"

function Container({ children, ...others }) {
	return (
		<Div pos="relative" maxW="calc(100% - 1rem)" m="auto" {...others}>
			{children}
		</Div>
	)
}

export default Container
